import { IS_FORD_BRAND } from "./EmpUtil";

export const ENROLLMENT_TERMS_TYPE = {
  FORD: "FORD",
  LINCOLN: "LINCOLN",
  DUAL: "DUAL",
};

/** Download filenames aligned with backend {@code EnrollmentTermsType}. */
export const ENROLLMENT_TERMS_FILENAME = {
  FORD: "Ford_EComm_TOC_ModelE_2023.pdf",
  LINCOLN: "Lincoln_eCommerce_Retailer_Participation_December_2025.pdf",
  DUAL: "eCommerce_Addendum_for_Dual_Ford_Lincoln_Stores_December_2025.pdf",
};

/**
 * Resolves which enrollment T&C document to display/accept for the current dealer context.
 *
 * <p>Rules:
 * <ul>
 *   <li>Ford brand (single or dual) → Ford TOC</li>
 *   <li>Lincoln-only dealer → Lincoln participation agreement</li>
 *   <li>Lincoln side of a dual dealer → dual Ford+Lincoln addendum</li>
 * </ul>
 *
 * @param {{ brand?: string, dualDealer?: boolean }} context
 * @returns {"FORD"|"LINCOLN"|"DUAL"}
 */
export function resolveEnrollmentTermsType({ brand, dualDealer = false }) {
  if (IS_FORD_BRAND(brand)) {
    return ENROLLMENT_TERMS_TYPE.FORD;
  }
  if (dualDealer) {
    return ENROLLMENT_TERMS_TYPE.DUAL;
  }
  return ENROLLMENT_TERMS_TYPE.LINCOLN;
}

export function getEnrollmentTermsFilename(termsType) {
  return (
    ENROLLMENT_TERMS_FILENAME[termsType] ?? "dealer-terms-and-conditions.pdf"
  );
}

export function getTermsAcceptanceSummary(t, acceptanceInfo) {
  const date = String(acceptanceInfo?.date ?? "").trim();
  const cdsid = String(acceptanceInfo?.cdsid ?? "").trim();
  const options = { interpolation: { escapeValue: false } };

  if (date && cdsid) {
    return t("DealerOnboarding.content.termsAndConditions.acceptedOn", {
      ...options,
      acceptedDate: date,
      cdsid,
      defaultValue: `Accepted on ${date} by ${cdsid}`,
    });
  }
  if (date) {
    return t("DealerOnboarding.content.termsAndConditions.acceptedOnDateOnly", {
      ...options,
      acceptedDate: date,
      defaultValue: `Accepted on ${date}`,
    });
  }
  if (cdsid) {
    return t("DealerOnboarding.content.termsAndConditions.acceptedByOnly", {
      ...options,
      cdsid,
      defaultValue: `Accepted by ${cdsid}`,
    });
  }
  return null;
}
